import New from "csi/table/New";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import Relationship from "csi/def/Relationship";
import csiStore from "csi/store/_base";
import Action from "csi/def/Action";
import ViewRef from "csi/def/ViewRef";
import StoreNamesConstructor, { StoreNames } from "csi/store/Names";

/** @property {string} MATERIAL - the node type used in the controller */
const MATERIAL = "Material";

const NewEngineeringChangeOnMaterial = declare(New, {

	/**
	 * @override
	 * Allow controller to add parameters to popup view
	 */
	onCreatePopupParams(params) {
		params.productLabel = MATERIAL;
		params.productStore = this._getMaterialStore();
	},

	/**
	 * Fetch list of all Materials
	 */
	_getMaterialStore(): StoreNames {
		const rel = lang.mixin(new Relationship(), {
			m_typeNode: MATERIAL,
		});

		const storeOptions = csiStore.namesOptionsByRelationship(this.getContext(), rel);
		storeOptions.data = [csiStore.nameObject("")];
		storeOptions.action = lang.mixin(new Action(), {
			m_viewRef: lang.mixin(new ViewRef(), {
				m_id: "AllMaterials",
				m_url: "centric://APPAREL/Views",
			}),
		});
		return new StoreNamesConstructor(storeOptions);
	},

	/**
	* @override
	* On material node, make the material as default & selected on engineering change form
	*/
	onCreatePopup(view) {
		view.addFixedValue(MATERIAL, this.m_urlParent);
		this.inherited(arguments);
	},

	/**
	 * @override
	 * Material is marked to be taken care on the server side
	 */
	toWriterRequest(fd: FormData): CallMethod {
		const call = this.inherited<CallMethod>(arguments);
		const materialURLs = this.m_formData.getFieldValue(MATERIAL, true);
		call.addParameter("AddURLs", xml.ATTR_REFLIST, materialURLs);
		return call;
	},
});

export = NewEngineeringChangeOnMaterial;